import { Typography, Image, Col, Row, Card } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons"
import MyCard from "../../../components/MyCard/MyCard";

export default function MainInfoUsage({
    myCardTitle,
    ImageWidth,
    ImageSrc,
    fontSize,
    TextOverImageInfo,
    TextInfo,
    borderRadiusInfo,
    transform,
    infoWidth,
    infoHeight,
    justifyContentTextInfo,
    paddingTopTextInfo,
    displayTextInfo
}) {
    const { Text } = Typography
    return (
        <MyCard title={myCardTitle}>
            <Row style={{ justifyContent: 'center' }} >
                <Col >
                    <Image width={ImageWidth} preview={false} src={ImageSrc} />
                </Col>
                <Col style={{
                    backgroundColor: '#00CBFF',
                    borderWidth: 1,
                    borderColor: '#00CBFF',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize,
                    position: 'absolute',
                    transform,
                    borderRadius: borderRadiusInfo,
                    width: infoWidth,
                    height: infoHeight
                }} >
                    <Text style={{
                        color: 'white',
                        justifyContent: justifyContentTextInfo,
                        display: displayTextInfo,
                        paddingTop: paddingTopTextInfo
                    }}>
                        {TextOverImageInfo}
                    </Text>
                </Col>
            </Row>
            <Card style={{ borderRadius: 10, borderWidth: 1 }}>
                <Row align="middle">
                    <Col xs={3}>
                        <InfoCircleOutlined style={{ fontSize: '150%', color: '#08c' }} theme="outlined" />
                    </Col>
                    <Col xs={20}>
                        <Text style={{ fontWeight: 'bold' }}>
                            {TextInfo}
                        </Text>
                    </Col>
                </Row>
            </Card>

        </MyCard>
    )
}


